export const NOT_AVAILABLE_FOR_REQUESTED_LANGUAGE = 'Not available for requested language';
